import PageName from './PageName';

export default PageName;
